'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, wideLabelsMode) {
  var groupsPadding = wideLabelsMode ? 0.4 : 0.17,
    edgeGroupsPadding = wideLabelsMode ? 0.2 : 0.05;
  var x = d3.scale.ordinal().domain(_.map(data, 'value')).rangeBands([0, params.width], groupsPadding, edgeGroupsPadding);
  var y = d3.scale.linear().domain([0, 1]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;